module.exports = __webpack_public_path__ + "static/media/pwa.1a60e8a9.webp";